/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Unit_BagInputs */

const vi_agri_unit_bag = /** @type {(inputs: Agri_Unit_BagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bao`)
};

/**

* @param {Agri_Unit_BagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_unit_bag = /** @type {((inputs?: Agri_Unit_BagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Unit_BagInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_unit_bag(inputs)
});